const reloadWindowIfTokenExpired = {
  methods: {
    reloadWindowIfTokenExpired(tokenExpired) {
      // if tokenExpired is true, reload window and also return true, in order to avoid proceeding to next line of code for all calls to this method
      if(!tokenExpired) return false
      if (tokenExpired === true) {
        console.warn('Window reloaded because token has expired!')
        window.location.reload()
        return true
      }
      return false
    },
  },
}
